export const tbrData = [
  "Heartstopper (4)",
  "Happy Land",
  "The Shift",
  "The Beauty in Breaking",
  "The Hot Zone",
  "This is Going to Hurt",
  "She Who Became the Sun",
  "Open Water",
  "Heartstopper (5)",
  "Queenie",
  "Crazy Rich Asians",
  "Magic Steeped in Poison",
  "Little Women",
  "Dallergut Dream Department Store",
  "Persephone Station",
  "The Warriors",
  "Hadestown",
  "Pachinko",
  "The Four Books",
  "The Future",
  "Crying in H-Mart",
  "The Mercies",
  "Harlem Shuffle",
  "Death of the Author",
  "Legends and Lattes",
  "How the Garcia Girls Lost Their Accident",
  "What My Bones Know",
  "Genesis of Misery",
  "Muted",
  "Love Hypothesis",
  "I Am Not Your Perfect Mexican Daughter",
  "Migrations",
  "A Thousand Ships",
  "Heartstopper (2)",
  "The Beautiful Ones",
  "Heartstopper (3)",
  "Ancillary Justice",
  "The Startup Wife",
  "S",
  "Lobizona",
  "Project Hail Mary",
  "The Girl with Stars in her Eyes",
  "The Long Way to a Small Angry Planet",
  "A Psalm for the Wild-built",
  "Orbital",
  "Beautiful Star",
  "Several people are typing",
  "Assassian's apprentice",
  "The Body",
  "I who have never known men",
  "Caine's jawbone",
  "A Black Woman's History of the United States",
  "James",
  "Gearbreakers",
  "The Taking of Jake Livingston"
];

export const shelfReadData = [
  "Gilded Ones",
  "Grown",
  "Chain-Gang All-Stars",
  "The Love Songs of W.E.B DuBois",
  "There, There",
  "tick, tick...BOOM!",
  "The Cybernetic Tea Shop",
  "Iron Heart",
  "Parable of the Sower",
  "Dawn",
  "In the Time of Butterflies",
  "Iron Widow",
  "Grace Year",
  "Heartstopper (1)",
  "She Came to Slay",
  "Kim Jiyoung, Born 1982",
  "Lakewood",
  "Monday's Not Coming",
  "The Afterlife of Holly Chase",
  "Redemptor",
  "White Smoke",
  "Cinderella is Dead",
  "Pet",
  "Wash Day Diaries",
  "Almond",
  "Raybearer",
  "Tower",
  "Binti",
  "Binti: Home",
  "Binti: Night Masquerade",
  "Such a Fun Age",
  "Ace of Spades",
  "Poison Heart",
  "Natural Beauty",
  "Deathless Divide",
  "The Year of the Witching",
  "Jade City",
  "Caste",
  "Master of Djinn",
  "Ring Shout",
  "Let me Hear a Ryhme",
  "Penance",
  "Allegedly",
  "Kindred",
  "Out There Screaming",
  "Confessions",
  "The Fifth Season",
  "The Stone Sky",
  "The Obelisk Gate",
  "Babel",
  "The Poppy War",
  "Yellowface",
  "All Systems Red",
  "Artificial Condition",
  "Rogue Protocol",
  "Exit Strategy",
  "Network Effect",
  "Fugitive Telemetry",
  "System Collapse"
];
